import {createReducer, on} from '@ngrx/store';
import {IMenuGroup} from "../models/menu-group";
import * as MenuGroupActions from './menu-group.actions';


export interface MenuGroupState {
  menuGroups: IMenuGroup[];
  loading: boolean;
  error: string;
}

export const initialState: MenuGroupState = {
  menuGroups: [],
  loading: false,
  error: ''
};
export const menuGroupReducer = createReducer(
  initialState,

  on(MenuGroupActions.loadMenuGroups, state => ({...state, loading: true})),

  on(MenuGroupActions.loadMenuGroupsSuccess, (state, {menuGroups}) => ({...state, menuGroups, loading: false})),

  on(MenuGroupActions.loadMenuGroupsFailure, (state, {error}) => ({...state, error, loading: false})),

  on(MenuGroupActions.addMenuGroup, (state, {menuGroup}) => ({...state, menuGroups: [...state.menuGroups, menuGroup]})),

  on(MenuGroupActions.updateMenuGroup, (state, {menuGroup}) => ({
    ...state,
    menuGroups: state.menuGroups.map(t => t.id === menuGroup.id ? menuGroup : t)
  })),

  on(MenuGroupActions.deleteMenuGroup, (state, {id}) => ({
    ...state,
    menuGroups: state.menuGroups.filter(t => t.id !== id)
  })),
);
